import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button, HollowButton } from '../Button';
import { SelectInput } from '../SelectInput';

const REASON_REQUIRED = 'A reason is required';

export function ReasonDialog({
	open,
	title,
	description,
	reasons,
	confirmLabel,
	destructive = false,
	error = null,
	onConfirm,
	onClose,
}) {
	const [reason, setReason] = useState('');

	const close = () => {
		setReason('');
		onClose();
	};

	const confirm = () => {
		onConfirm({ reason });
		setReason('');
	};

	return (
		<Dialog open={open} onClose={close} fullWidth maxWidth="xs">
			<DialogTitle>{title}</DialogTitle>
			<DialogContent>
				{description ? <DialogContentText>{description}</DialogContentText> : null}
				<SelectInput
					label="Reason"
					placeholder="Select a reason"
					options={reasons}
					value={reason}
					onChange={(event) => setReason(event.target.value)}
				/>
				{!reason ? (
					<DialogContentText style={{ fontSize: 13, color: '#c00' }}>
						{REASON_REQUIRED}
					</DialogContentText>
				) : null}
				{error ? <DialogContentText style={{ color: '#c00' }}>{error}</DialogContentText> : null}
			</DialogContent>
			<DialogActions>
				<HollowButton size="small" onClick={close}>Back</HollowButton>
				<Button
					size="small"
					flavour={destructive ? 'danger' : 'primary'}
					disabled={!reason}
					title={reason ? undefined : REASON_REQUIRED}
					onClick={confirm}
				>
					{confirmLabel}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
